import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { AdviseSupplier } from '../../../../types/advise';
import { formatCurrency } from '../../../../utils/helpers';
import { SupplierRoiResult } from './RoiAnalysisPanel.calc';
import { RoiSummaryRow } from './RoiSummaryRow';

const formatPct = (pct: number) => {
  if (!pct || isNaN(pct)) return '0%';
  return `${Math.round(pct)}%`;
};

export const RoiSummaryCard = ({ supplier, roi }: { supplier: AdviseSupplier; roi: SupplierRoiResult }) => (
  <Card variant="outlined">
    <CardContent>
      <Typography
        variant="subtitle2"
        gutterBottom>
        {supplier.supplier_name}
      </Typography>
      <Box className="flex flex-col gap-1">
        <RoiSummaryRow label="Annual Savings">
          <Typography
            variant="body2"
            color={roi.annualSavings > 0 ? 'success.main' : 'error.main'}>
            {formatCurrency(roi.annualSavings, { decimals: 0 })}
          </Typography>
        </RoiSummaryRow>
        <RoiSummaryRow label="Added Revenue">
          <Typography variant="body2">{formatCurrency(roi.addedRevenue, { decimals: 0 })}</Typography>
        </RoiSummaryRow>
        <RoiSummaryRow label="Net Year 1">
          <Typography
            variant="subtitle2"
            color={roi.netYear1 > 0 ? 'success.main' : 'error.main'}>
            {formatCurrency(roi.netYear1, { decimals: 0 })}
          </Typography>
        </RoiSummaryRow>
        <Box className="flex justify-end mt-1">
          <Chip
            label={`${formatPct(roi.roiPct)} ROI`}
            size="small"
            color={roi.roiPct > 0 ? 'success' : 'error'}
          />
        </Box>
      </Box>
    </CardContent>
  </Card>
);
